/**
 * MCQ (Multiple Choice Question) Element
 */

import type { ElementDefinition } from '@ai-content-hub/content-kit';
import {
    mcqElementSchema,
    type MCQElementData,
    type MCQChoice,
    type MCQAnswer,
    type MCQContent,
    type MCQContentType,
    type MCQTextContent,
    type MCQImageContent,
    type MCQAudioContent,
    type MCQVideoContent,
    type MCQRichTextContent,
    getContentPreview,
    createDefaultContent,
    getDisplayContent,
    normalizeMCQData,
    getQuestionText,
} from './schema';
import { MCQEdit } from './MCQEdit';
import { MCQPlayer } from './MCQPlayer';
import { mcqGrader, isMcqAnswered } from './grader';

// Export types
export {
    mcqElementSchema,
    type MCQElementData,
    type MCQChoice,
    type MCQAnswer,
    type MCQContent,
    type MCQContentType,
    type MCQTextContent,
    type MCQImageContent,
    type MCQAudioContent,
    type MCQVideoContent,
    type MCQRichTextContent,
};

// Export helpers
export {
    getContentPreview,
    createDefaultContent,
    getDisplayContent,
    normalizeMCQData,
    getQuestionText,
};

// Export components
export { MCQEdit };
export { MCQPlayer };
export type { MCQAnswerChoicesPresentation, MCQPlayerProps } from './MCQPlayer';
export { mcqGrader, isMcqAnswered };

export const mcqElement: ElementDefinition<MCQElementData, MCQAnswer> = {
    schema: mcqElementSchema,
    EditComponent: MCQEdit as any,
    PlayerComponent: MCQPlayer as any,
    grader: mcqGrader,
    validator: {
        validate: mcqGrader.validate!,
    },
};
